import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import StrainPage from './pages/StrainPage';
import StrainInsights from './pages/StrainInsights';
import StrainProfile from './pages/StrainProfile';

// Simple auth check - only used for routes that require login
const ProtectedRoute = ({ children }) => {
  const isAuth = sessionStorage.getItem('auth') === 'true';
  return isAuth ? children : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      {/* Strain pages are public - auth determines which view is shown */}
      <Route path="/mimosa" element={<StrainPage strain="Mimosa" />} />
      <Route path="/max-ac" element={<StrainPage strain="Max AC" />} />
      {/* Protected: authenticated users only */}
      <Route path="/strain-insights" element={
        <ProtectedRoute><StrainInsights /></ProtectedRoute>
      } />
      <Route path="/strain-profile" element={
        <ProtectedRoute><StrainProfile /></ProtectedRoute>
      } />
    </Routes>
  );
}